import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from 'gridjs-react';
import { html } from 'gridjs';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Modal, ModalBody, Button } from '../../../Components/ui';
import { API, BACKEND_HOST } from '../../../api';
import { SUBDOMAIN } from '../../../assets/meta/meta';
import { dialogService } from "@/utils/dialogService";
export default function B2BVoucherList() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [rawData, setRawData] = React.useState<any[]>([]);
    const [delRecord, setDelRecord] = React.useState<number | null>(null);
    const [modalDelete, setModalDelete] = React.useState(false);
    const [shareRecord, setShareRecord] = React.useState<string | null>(null);
    const [modalShare, setModalShare] = React.useState(false);
    const handleEdit = useCallback((id: number) => {
        navigate(`/b2b-voucher-form/${id}`);
    }, [navigate]);
    const handleDelete = useCallback((id: number) => {
        setDelRecord(id);
        setModalDelete(true);
    }, []);
    const handleShare = useCallback(async (id: number) => {
        const item = rawData.find(item => item.id === id);
        if (!item || !item.share_pin_code) {
            await dialogService.handleAlert("공유 링크를 사용할 수 없습니다. 쿠폰 상태를 확인해주세요.");
            return;
        }
        setShareRecord(`https://${SUBDOMAIN}.${window.AMZ_ENV.REACT_APP_DOMAIN}/promotion/voucher/${item.share_pin_code}/`);
        setModalShare(true);
    }, [rawData]);
    // Event listeners for gridjs button clicks (since html() doesn't support React onClick)
    useEffect(() => {
        const handleEditEvent = (e: CustomEvent) => {
            handleEdit(e.detail);
        };
        const handleDeleteEvent = (e: CustomEvent) => {
            handleDelete(e.detail);
        };
        const handleShareEvent = (e: CustomEvent) => {
            handleShare(e.detail);
        };
        window.addEventListener('editB2BVoucher', handleEditEvent as EventListener);
        window.addEventListener('deleteB2BVoucher', handleDeleteEvent as EventListener);
        window.addEventListener('shareB2BVoucher', handleShareEvent as EventListener);
        return () => {
            window.removeEventListener('editB2BVoucher', handleEditEvent as EventListener);
            window.removeEventListener('deleteB2BVoucher', handleDeleteEvent as EventListener);
            window.removeEventListener('shareB2BVoucher', handleShareEvent as EventListener);
        };
    }, [handleEdit, handleDelete, handleShare]);
    const fields = [
        {
            name: "id",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "name",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "username",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "expire_date",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "stock",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: 'Share',
            width: '60px',
            formatter: (cell: any) => {
                const safeId = Number(cell);
                if (!Number.isFinite(safeId)) {
                    return html('');
                }
                return html(`<div class="d-flex gap-2">
					<div class="get-link">
						<button class="btn btn-sm btn-secondary get-link-btn" onclick="window.dispatchEvent(new CustomEvent('shareB2BVoucher', {detail: ${safeId}}))">링크</button>
					</div>
				</div>`);
            }
        },
        {
            name: 'Actions',
            width: '140px',
            formatter: (cell: any) => {
                const safeId = Number(cell);
                if (!Number.isFinite(safeId)) {
                    return html('');
                }
                return html(`<div class="d-flex gap-2">
					<div class="edit">
						<button class="btn btn-sm btn-success edit-item-btn" onclick="window.dispatchEvent(new CustomEvent('editB2BVoucher', {detail: ${safeId}}))">Edit</button>
					</div>
					<div class="remove">
						<button class="btn btn-sm btn-danger remove-item-btn" onclick="window.dispatchEvent(new CustomEvent('deleteB2BVoucher', {detail: ${safeId}}))">Delete</button>
					</div>
				</div>`);
            }
        }
    ];
    function fetchData() {
        API.get(`${BACKEND_HOST}/voucher/b2b-stock/`)
            .then((res) => {
                const rows = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
                setRawData(rows);
                const fieldList = ["id", "name", "username", "expire_date", "stock"];
                let dataArr = [];
                rows.forEach((item) => {
                    let itemValues = [];
                    fieldList.forEach((field) => {
                        itemValues.push(item[field]);
                    });
                    itemValues.push(item.id);
                    itemValues.push(item.id);
                    dataArr.push(itemValues);
                });
                setData(dataArr);
            })
            .catch(e => console.log(e));
    }
    React.useEffect(() => {
        fetchData();
    }, []);
    const deleteRecord = () => {
        API.delete(`${BACKEND_HOST}/voucher/b2b-stock/${delRecord}/`)
            .then(async (data) => {
                await dialogService.handleAlert("Delete ok!");
                setModalDelete(false);
                fetchData();
            })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    return (<React.Fragment>
        <div className="page-content">
            <div className="container-fluid">
                <BreadCrumb title="제휴-무료쿠폰 목록" pageTitle="쿠폰" />
                <div className="flex flex-wrap -mx-3">
                    <div className="w-full px-3">
                        <div className="card">
                            <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <h4 className="card-title mb-0 flex-grow-1">B2B 제휴쿠폰 목록</h4>
                                <div>
                                    <Button onClick={() => { navigate(`/b2b-voucher-form/${0}`); }} id="create-btn" color="success" className="add-btn me-1"><i className="ri-add-line align-bottom me-1"></i> 등록</Button>

                                </div>
                            </div>

                            <div className="card-body">
                                <div id="voucher-table-gridjs">
                                    <Grid data={data} columns={fields} search={false} sort={true} pagination={{ limit: 10, }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal isOpen={modalDelete} onClose={() => setModalDelete(false)}>
            <ModalBody className="text-center p-5">
                <div className="mt-4">
                    <h4 className="mb-3">Are you Sure ?</h4>
                    <p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
                    <div className="hstack gap-2 justify-content-center">
                        <Button onClick={() => { setDelRecord(null); setModalDelete(false); }} color="light">Cancel</Button>
                        <Button onClick={deleteRecord} color="danger">Delete</Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>


        <Modal isOpen={modalShare} onClose={() => setModalShare(false)}>
            <ModalBody className="text-center p-5">
                <div className="mt-4">
                    <h4 className="mb-3">공유 링크</h4>
                    <p className="text-muted mb-4">아래 링크를 복사하여 공유하세요.</p>
                    <div className="hstack gap-2 justify-content-center mb-3">
                        <input type="text" className="form-control" value={shareRecord || ''} readOnly />
                    </div>
                    <div className="hstack gap-4 justify-content-center">
                        <a href={shareRecord || '#'} target="_blank" rel="noreferrer">링크 바로가기</a>
                        <Button onClick={() => { setModalShare(false); }} color="light">Close</Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>

    </React.Fragment>);
}
